<div class="footerPayment__logos">
  <ng-container *ngFor="let method of payments">
    <vc-svg-cart-payment class="footerPayment__logos__icon" [payment]="method.mnemonic"></vc-svg-cart-payment>
  </ng-container>
  <div class="footerPayment__logos__subpart" *ngIf="isGermany">
    <div
      id="VestiaireCollectiveTrustBadge"
      class="footerPayment__logos__trustedShop"
      style="width:101px;height:54px"
    ></div>
    <img
      src="/assets/images/cart/dhl-express.svg"
      width="59"
      height="18"
      class="footerPayment__logos__icon footerPayment__logos__icon--dhl_express"
    />
  </div>
</div>
